export enum gameStateActions {
  SET_CURRENT_ATTEMPT = "SET_CURRENT_ATTEMPT",
  SET_PREVIOUS_ATTEMPT = "SET_PREVIOUS_ATTEMPT",
  SET_GAME_OVER_MESSAGE = "SET_GAME_OVER_MESSAGE",
  APPEND_CURRENT_ATTEMPT = "APPEND_CURRENT_ATTEMPT",
  APPEND_PREVIOUS_ATTEMPT = "APPEND_PREVIOUS_ATTEMPT",
  BACKSPACE_CURRENT_ATTEMPT = "BACKSPACE_CURRENT_ATTEMPT",
  RESET_GAME_STATE = "RESET_GAME_STATE",
}
